import React, { ReactElement } from 'react';

import { useShimmingLoaderStyles } from './ShimmingLoaderStyles';

export const ShimmingLoader = (): ReactElement => {
    const classes = useShimmingLoaderStyles();
    return <div className={classes.container} />;
};
